module.exports = __webpack_public_path__ + "img/2.cf03d092.jpg";